angular
    .module('annexaApp')
    .component('annexaBoxProposalDocuments',{
        templateUrl: './components/doc/annexa-box-proposal-documents/annexa-box-proposal-documents.html',
        controller:['$scope', 'Language', 'GlobalDataFactory','$rootScope','DccumentsFactory', 'AnnexaDocumentActionsButtonFactory', '$filter', 'AnnexaPermissionsFactory','$state', function($scope, Language, GlobalDataFactory, $rootScope, DccumentsFactory, AnnexaDocumentActionsButtonFactory, $filter, AnnexaPermissionsFactory, $state) {
            var vm = this;   
            vm.languageColumn = Language.getActiveColumn();
            
            vm.getDocStatusTitle = function (document) {
                return 'global.documentState.' + document.docStatus;
            }

            vm.getDocStatusIcon = function (document) {
                switch (document.docStatus) {
                    case 'NEW':
                        return 'fa fa-circle-o text-blue fa-lg';
                        break;
                    case 'NEW_AND_ATTACHMENT':
                        return 'fa fa-adjust text-blue fa-lg';
                        break;
                    case 'PENDING_SIGN':
                        return 'fa fa-circle text-blue fa-lg';
                        break;
                    case 'SIGNED':
                        return 'fa fa-circle text-success fa-lg';
                        break;
                    case 'REJECTED':
                        return 'fa fa-circle text-danger fa-lg';
                        break;
                    case 'COMPLETE':
                        return 'fa fa-dot-circle-o text-success fa-lg v-t';
                        break;
                    case 'ARCHIVED':
                        return 'fa fa-circle-o text-success fa-lg v-t';
                        break;

                }
            }
            
            vm.documentIsExpired = function(expirationDate){
				var documentIsExpired = false;
				if(expirationDate){
					if(expirationDate instanceof Date){
						if(expirationDate < new Date()){
							documentIsExpired = true;
						}
					}else {
						if(new Date(expirationDate) < new Date()){
							documentIsExpired = true;
						}
					}
				}
				return  documentIsExpired;
			}
            
            vm.viewDocument = function(document){
                if(document) {
                    $rootScope.loading(true);
                    var windowReference = window.open();
                    DccumentsFactory.getDocContent(document.id)
                        .then(function(data) {
                            $rootScope.loading(false);
                            windowReference.location = data;
                    }).catch(function (error) {
                        $rootScope.loading(false);
                        windowReference.close();
                    });
                }
            }
            vm.authCopyDocument = function(document){
                 $rootScope.loading(true);
                 var windowReference = window.open();
                 DccumentsFactory.getAuthCopyContent(document.id)
                 .then(function(data) {
                     $rootScope.loading(false);
                     windowReference.location = data;
                 }).catch(function (error) {
                     $rootScope.loading(false);
                     windowReference.close();
                 });
            }
            vm.canShowDocument = function (document) {
            	if(document && document.docStatus != 'ARCHIVED'){
                    if(AnnexaPermissionsFactory.havePermission('view_documents')) {
                        if (vm.origin && _.contains(['THIRD', 'DILIGENCE', 'DOSSIER', 'TASK', 'SEC'], vm.origin)) {
                            return true;
                        }
                        if(vm.origin != 'NOTIFICATION' && $state.current && $state.current.name && ($state.current.name == 'annexa.reg.input.entries.edit' || $state.current.name == 'annexa.reg.input.entries.new' || $state.current.name == 'annexa.reg.output.entries.new' || $state.current.name == 'annexa.reg.output.entries.edit' || $state.current.name == 'annexa.reg.view' || $state.current.name == 'annexa.reg.viewInput' || $state.current.name == 'annexa.reg.viewOutput' || $state.current.name == 'annexa.reg.viewByNumberInput') && AnnexaPermissionsFactory.havePermission('view_register_entry_documents')){
                            return true;
                        }
                        if(document && document.profiles) {
                            var userProfiles = $linq($rootScope.LoggedUser.userProfiles).select("x => x.profile.id").toArray();
                            var documentProfiles = $linq(document.profiles).select("x => x.profile.id").toArray();
                            var intersect = $linq(userProfiles).intersect(documentProfiles, "(x,y) => x == y").toArray();
                            var documentTypeProfilesTotalAcces = [];
                            if(document && document.type && document.type.id){
                            	var dtype = $linq(GlobalDataFactory.documentTypes).firstOrDefault(undefined,"x => x.id == "+document.type.id);
                            	if(dtype && dtype.profilesTotalAcces){
                            		var documentTypeProfilesTotalAcces = $linq(dtype.profilesTotalAcces).select("x => x.profile.id").toArray();
                            	}
                            } 
                            var intersectDocType = $linq(userProfiles).intersect(documentTypeProfilesTotalAcces, "(x,y) => x == y").toArray();
                            return intersect.length > 0 || intersectDocType.length > 0 ;
                        } 
                    }
            	}
                return false;
            }
            vm.getTitleDocumentView = function(type){
                var titleDocView = "";
                if(type == "authCopy"){
                    titleDocView = "[" + $filter('translate')('global.literals.seeAuthCopy') + "]";
                }else{
                    titleDocView = "[" + $filter('translate')('global.literals.seeDocument') + "]";
                }
                
                return titleDocView;
            }
            vm.showViewDocument = function(document){
                if(AnnexaDocumentActionsButtonFactory.isDocumentConvertibleToPdf(document, true)){
                    return true;
                }
                return false;
            }
            vm.lastSignProcess = function (document){
            	return $linq(document.signProcesses).orderByDescending("x => x.createdDate").firstOrDefault("undefined");
            }
            vm.getCircuitStatusIcon = function (signState){
            	switch (signState) {
            		case 'PENDING':
            			return 'fa fa-circle text-grey';
            			break;
            		case 'REJECTED':
            			return 'fa fa-circle text-danger';
            			break;
            		case 'IDLE':
            			return 'fa fa-circle text-grey';
            			break;
            		case 'FINALLY':
            			return 'fa fa-circle text-success';
            			break;
            		case 'NONEED':
            			return 'fa fa-circle text-success';
            			break;
            	}
            }
            vm.getUserName = function(action, user) {
                if(user) {
                	return user.name + ' ' + user.surename1 + (user.surename2 ? ' ' + user.surename2 : '');
                } else if (action.userSign || action.userMustSign){
                	var user = action.userSign ? action.userSign : action.userMustSign;
                	return user.name + ' ' + user.surename1 + (user.surename2 ? ' ' + user.surename2 : '');
                } else if (action.signActionType && action.signActionType.code && action.signActionType.code == 'AUTOSIGN_ORGAN'){
                	return action.signActionType[vm.languageColumn];
                } else{
                	return '';
                }
            }
            vm.getPrintThird = function(third, thirdAddress) {
            	var name = '';
                if(third.corporateName) {
                	name = third.corporateName;
                } else {
                	name = third.name + ' ' + third.surename1;
                }

                if(third.surename2) {
                	name += ' ' + third.surename2;
                }
                
                if(thirdAddress && thirdAddress.telematicValue) {
                	name += ' (' + thirdAddress.telematicValue + ')';
                }
                
                return name;
            }
            this.$onInit = function() {
                vm.docModule = $linq(GlobalDataFactory.modules).where("x => x.url == 'annexa.doc.documents.all'").toArray();

                if(!vm.boxTitle) {
                    vm.boxTitle = 'global.literals.documents';
                }

                if(!vm.permissions) {
                    vm.permissions = {};
                }

            	if(!vm.module){
            		vm.module = 'SEC';
            	}
            }
        }],
        bindings: {
            boxTitle: '@?',
            module: '=?',
            permissions: '=',
            content: '=',
            emptyText: '@',
            config: '=',
            origin: '@'
        }
    })